<template>
  <div>
    <datalist id="non-dismissed-towns-list">
      <option v-for="town in towns.keys()"> {{ town }}</option>
    </datalist>
    <b-form-row>
      <b-form-group label="Tipo di Domanda" class="col-md-6">
        <b-form-select
          id="demand-type"
          name="Tipo di Domanda"
          v-model="customer.demandType"
          :options="demandTypes()"
          :disabled="true"
          v-validate="{ required: true }"
          :state="stateValidation('Tipo di Domanda')"
          aria-describedby="input-demandtype-feedback">
        </b-form-select>
        <b-form-invalid-feedback id="input-demandtype-feedback">{{
            veeErrors.first('Tipo di Domanda')
          }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Punto Vendita" class="col-md-6">
        <ShopSelect id="store-code" v-model="customer.shopCode" description="Punto vendita"
                    :required="true" ref="store-code"/>
      </b-form-group>
      <b-form-group v-if="customer.demandType === 'REISSUE'" label="Codice vecchia Tessera" class="col-md-2">
        <b-form-input
          :disabled="true"
          name="Codice vecchia Tessera"
          v-model="customer.oldBarcode"
          class="fix-radius"
        />
      </b-form-group>
    </b-form-row>
    <hr>
    <b-form-row>
      <b-form-group class="col-md-12">
        <h4>Residenza</h4>
        <b-form-group>
          <b-form-radio id="italy-residence-nation" v-model="residenceNation" value="Italy"
                        v-on:change="initResidence()">Italia
          </b-form-radio>
          <b-form-radio id="foreign-residence-nation" v-model="residenceNation" value="Foreign"
                        v-on:change="initResidence()">Estero
          </b-form-radio>
        </b-form-group>
        <b-form-row>
          <b-form-group label="Via" class="col-md-8">
            <b-input-group>
              <b-form-input
                autocomplete="off"
                id="street"
                v-model="customer.street"
                name="Via"
                v-validate="{ required: true }"
                :state="stateValidation('Via')"
                aria-describedby="input-street-feedback"/>
              <b-form-invalid-feedback id="input-street-feedback">{{
                  veeErrors.first('Via')
                }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group label="Numero civico" class="col-md-2">
            <b-input-group>
              <b-form-input
                autocomplete="off"
                id="civic-number"
                v-model="customer.civicNumber"
                name="Numero Civico"
                v-validate="{ required: true, max: 15 }"
                :state="stateValidation('Numero Civico')"
                aria-describedby="input-civicnumber-feedback"/>
              <b-form-invalid-feedback id="input-civicnumber-feedback">{{
                  veeErrors.first('Numero Civico')
                }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group label="CAP" class="col-md-3" v-if="residenceNation === 'Italy'">
            <b-form-input
              autocomplete="off"
              id="postal-code"
              v-model="customer.postalCode"
              name="CAP"
              v-validate="{ required: true, numeric: true, min: 5, max: 5 }"
              :state="stateValidation('CAP')"
              aria-describedby="input-postalcode-feedback"/>
            <b-form-invalid-feedback id="input-postalcode-feedback">{{
                veeErrors.first('CAP')
              }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Città" class="col-md-6" v-if="residenceNation === 'Italy'">
            <b-input-group>
              <b-form-input
                autocomplete="off"
                id="it-residence-city"
                v-on:input="handleSearchInput"
                v-on:blur="validateResidenceCity()"
                v-model="customer.town"
                name="Residenza"
                :state="stateValidation('Residenza')"
                aria-describedby="input-residence-feedback"
              />


              <div v-if="filteredList.length > 0 && isResidenceSearchActive" class="suggestions-list">
                <div
                  v-for="(item, index) in filteredList"
                  :key="index"
                  class="suggestion-item"
                  @click="handleResidenceSelection(item)"
                >
                  {{ item.name }} - {{ item.provinceCode }}
                </div>
              </div>

              <b-form-invalid-feedback id="input-city-feedback">
                {{ veeErrors.first('Città') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Città estera" class="col-md-4" v-if="residenceNation === 'Foreign'">
            <b-input-group>
              <b-form-input
                autocomplete="off"
                id="foreign-town"
                v-model="customer.town"
                name="Città estera"
                v-validate="{ required: true }"
                :state="stateValidation('Città estera')"
                aria-describedby="input-city-feedback"/>
              <b-form-invalid-feedback id="input-city-feedback">{{
                  veeErrors.first('Città estera')
                }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Provincia" class="col-md-2" v-if="residenceNation === 'Italy'">
            <b-form-input
              id="province"
              readonly
              v-model="customer.province"
              name="Provincia"
              v-validate="{ required: true, min: 2, max: 2 }"
              :state="stateValidation('Provincia')"
              aria-describedby="input-province-feedback"/>
            <b-form-invalid-feedback id="input-province-feedback">
              {{ veeErrors.first('Provincia') }}
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Nazione" class="col-md-3" v-if="residenceNation === 'Foreign'">
            <b-input-group>
              <b-form-input
                autocomplete="off"
                id="nation"
                list="nations-list"
                v-model="customer.nation"
                name="Nazione"
                v-validate="validateNation()"
                :state="stateValidation('Nazione')"
                aria-describedby="input-nation-feedback"/>
              <b-form-invalid-feedback id="input-nation-feedback">{{
                  veeErrors.first('Nazione')
                }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
        </b-form-row>
      </b-form-group>
    </b-form-row>
    <hr>
    <b-form-row>
      <b-form-group class="col-md-12">
        <h4>Contatti</h4>
        <b-form-row>
          <b-form-group label="Cellulare" class="col-md-6">
            <b-input-group>
              <b-input-group-prepend>
                <b-select id="mobile-phone-prefix" v-model="customer.mobilePhonePrefix"
                          :options="mobilePhonePrefixes"/>
              </b-input-group-prepend>
              <b-form-input
                autocomplete="off"
                id="mobile-phone-number" v-model="customer.mobilePhone"
                name="Cellulare"
                v-validate="{ numeric: true, min:5, mobilePhoneValidator: true }"
                :state="stateValidation('Cellulare')"
                aria-describedby="input-mobile-phone-feedback"/>
              <b-form-invalid-feedback id="input-mobile-phone-feedback">
                {{ veeErrors.first('Cellulare') }}
              </b-form-invalid-feedback>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Telefono fisso" class="col-md-6">
            <b-input-group>
              <b-form-input
                autocomplete="off"
                v-model="customer.telephone"
                id="telephone"/>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Email" class="col-md-12">
            <b-form-input
              autocomplete="off"
              v-model="customer.email"
              id="email"
              name="Email"
              v-validate="{ email: true }"
              :state="stateValidation('Email')"
              aria-describedby="input-email-feedback"/>
            <b-form-invalid-feedback id="input-email-feedback">
              {{ veeErrors.first('Email') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-row>
      </b-form-group>
    </b-form-row>
    <hr>
    <b-form-row>
      <b-form-group class="col-md-12">
        <h4>Consensi</h4>
        <b-form-checkbox-group v-model="customer.selectedConsensuses" size="lg">
          <b-form-checkbox id="marketing" value="marketing">Marketing</b-form-checkbox>
          <b-form-checkbox id="profiling" value="profiling">Profilazione</b-form-checkbox>
          <b-form-checkbox id="cooperatives" value="cooperatives">Cooperativi</b-form-checkbox>
          <b-form-checkbox id="third-party" value="third-party">Terze parti</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
    </b-form-row>
    <hr>
    <b-form-row>
      <b-form-group label="Codice Fiscale" class="col-md-8">
        <FiscalCode id="fiscal-code" v-model="customer.fiscalCode"></FiscalCode>
      </b-form-group>
      <b-form-group class="col-md-12">
        <h4>Dati Familiari (opzionali)</h4>
        <b-form-row>
          <b-form-group label="Numero membri familiari" class="col-md-4">
            <b-form-input v-validate="{ numeric: true }"
                          name="Numero Membri Familiari"
                          :state="stateValidation('Numero Membri Familiari')"
                          autocomplete="off"
                          id="family-number"
                          v-model="customer.familyNumber"
                          aria-describedby="input-email-feedback"/>
            <b-form-invalid-feedback id="input-family-number-feedback">
              {{ veeErrors.first('Numero Membri Familiari') }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-form-row>
        <b-form-row>
          <b-form-group label="Date di nascita:" class="col-md-12 mb-0"></b-form-group>
          <b-form-group label="Primo figlio" class="col-md-4">
            <DatePicker id="child1-birth-date" description="Data nascita primo figlio"
                        ref="child1-birth-date" v-model="customer.child1BirthDate"/>
          </b-form-group>
          <b-form-group label="Secondo figlio" class="col-md-4">
            <DatePicker id="child2-birth-date" description="Data nascita secondo figlio"
                        ref="child2-birth-date" v-model="customer.child2BirthDate"/>
          </b-form-group>
          <b-form-group label="Terzo figlio" class="col-md-4">
            <DatePicker id="child3-birth-date" description="Data nascita terzo figlio"
                        ref="child3-birth-date" v-model="customer.child3BirthDate"/>
          </b-form-group>
        </b-form-row>
      </b-form-group>
    </b-form-row>
    <b-row align-h="end" class="mr-2">
      <b-button @click="switchTab" id="fill-secondary-button" variant="primary">Conferma</b-button>
    </b-row>
  </div>
</template>

<script>
import phonePrefixes from '@/assets/phone-prefix.json'
import DatePicker from '@/components/DatePicker'
import FiscalCode from '@/components/new-agreement/FiscalCode'
import demandsType from '../../DemandsType'
import ShopSelect from '@/components/ShopSelect'
import {isValidPhoneNumber} from "libphonenumber-js";
import eventBus from '@/EventBus'


export default {
  name: 'CustomerSecondaryData',
  components: {DatePicker, FiscalCode, ShopSelect},
  props: ["nations", "towns"],
  provide() {
    return {parentValidator: this.$validator}
  },
  data: () => ({
    residenceNation: 'Italy',
    mobilePhonePrefixes: phonePrefixes
      .filter(prefix => prefix.code === 'IT' || prefix.code === 'CH' || prefix.code === 'DE')
      .map(prefix => ({text: `${prefix.name} (${prefix.code}) ${prefix.prefix}`, value: prefix.prefix}))
      .sort((firstPrefix, secondPrefix) => ('' + firstPrefix.name).localeCompare(secondPrefix.name)),
    demandsType: demandsType,
    customer: {},
    residenceSearch: '',
    isResidenceSearchActive: false,
  }),
  mounted() {
    eventBus.$on('reset-state', () => {
      this.customer = {}
      this.$refs['child1-birth-date'].reset()
      this.$refs['child2-birth-date'].reset()
      this.$refs['child3-birth-date'].reset()
      this.$refs['store-code'].reset()
      this.$validator.reset()
    })
    eventBus.$on("shop-selected", res => {
      this.setDemandTypeOnShopChange(res)
    })

    eventBus.$on("customer-found", this.fillSecondaryData)
    this.$validator.extend('mobilePhoneValidator', {
      getMessage: field => {
        let prefix = phonePrefixes.find(prefix => prefix.prefix === this.customer.mobilePhonePrefix);
        if (prefix) {
          return `Il numero di ${field} non è valido`
        } else {
          return `Il prefisso non è valido`
        }
      },
      validate: value => {
        let prefix = phonePrefixes.find(prefix => prefix.prefix === this.customer.mobilePhonePrefix);
        if (prefix) {
          return isValidPhoneNumber(value, prefix.code)
        }
        return false
      }
    })
  },
  beforeDestroy() {
    eventBus.$off("shop-selected")
  },

  computed: {
    filteredList() {
      console.log(this.towns)
      return this.towns.filter(item => {
        const search = this.residenceSearch.toLowerCase()
        return (
          item.name.toLowerCase().includes(search)
        )
      })
    }
  },
  methods: {
    handleSearchInput(value) {
      console.log("TEsto cambiato Residence Select")
      this.residenceSearch = value
      this.isResidenceSearchActive = true
    },

    handleResidenceSelection(value) {
      this.customer.town = value.name;
      this.fillResidenceProvince(value.provinceCode);
      this.isResidenceSearchActive = false
    },

    demandTypes: () => demandsType,
    setDemandTypeOnShopChange(shopCode) {
      if (this.customer.demandType !== 'NEW') {
        this.customer.demandType = shopCode !== this.customer.shopCode ? 'ADMIN_UPDATE' : 'UPDATE'
      }

      this.customer.shopCode = shopCode
    },
    switchTab() {
      this.$validator.validateAll().then(result => {
        if (result) {
          eventBus.$emit("secondary-data-filled", this.customer)
          eventBus.$emit("switch-tab", 2)
        }
      })
    },
    fillSecondaryData(customer) {
      this.customer.demandType = this.setDemandType(customer)

      if (this.customer.demandType !== 'NEW') {
        this.customer.oldBarcode = customer.oldBarcode

        this.residenceNation = (customer.residence.nation == null || customer.residence.nation.toUpperCase() !== 'ITALIA') ? 'Foreign' : 'Italy'

        this.customer.nation = customer.residence.nation ? customer.residence.nation.toUpperCase() : "ITALIA"
        this.customer.street = customer.residence.street
        this.customer.civicNumber = customer.residence.number
        this.customer.postalCode = customer.residence.postalCode
        this.customer.town = customer.residence.city
        this.customer.province = this.isNotItaly(customer.residence.nation) && customer.residence.province === null ? 'EE' : customer.residence.province
        const mobilePhone = customer.mobilePhone !== null ? customer.mobilePhone.split(' ') : []

        if (mobilePhone.length === 1) {
          this.customer.mobilePhone = mobilePhone[0]
        } else if (mobilePhone.length === 2) {
          this.customer.mobilePhonePrefix = mobilePhone[0]
          this.customer.mobilePhone = mobilePhone[1]
        }
        this.customer.selectedConsensuses = []
        if (customer.marketingConsensus) this.customer.selectedConsensuses.push("marketing")
        if (customer.profilingConsensus) this.customer.selectedConsensuses.push("profiling")
        if (customer.cooperativesConsensus) this.customer.selectedConsensuses.push("cooperatives")
        if (customer.thirdPartyConsensus) this.customer.selectedConsensuses.push("third-party")

        this.customer.telephone = customer.telephone
        this.customer.fiscalCode = customer.fiscalCode
        this.customer.email = customer.email
        this.customer.familyNumber = customer.familyNumber
        this.customer.child1BirthDate = customer.firstChildBirthDate
        this.customer.child2BirthDate = customer.secondChildBirthDate
        this.customer.child3BirthDate = customer.thirdChildBirthDate
        this.customer.shopCode = customer.shopCode

        eventBus.$emit('set-shop', customer.shopCode)
      }
      this.$forceUpdate()
    },
    isNotItaly(nation) {
      return nation ? nation.toUpperCase() === 'ITALIA' : false
    },
    setDemandType(customer) {
      if (customer == null)
        return 'NEW'

      return customer.oldBarcode ? 'REISSUE' : 'UPDATE'
    },
    initResidence() {
      this.customer.residenceNation = this.residenceNation
      this.customer.town = null
      this.customer.province = this.residenceNation === 'Italy' ? null : "EE"
      this.customer.street = null
      this.customer.civicNumber = null
      this.customer.nation = this.residenceNation === 'Italy' ? "ITALIA" : null
      this.customer.postalCode = null

      this.$forceUpdate()
    },
    fillResidenceProvince(code) {
      if (this.residenceNation === 'Italy') {
        this.customer.province = code
        this.$forceUpdate()
      }
    },
    validateResidenceCity() {
      if (!this.towns.filter(town => town.name === this.customer.town)) {
        this.customer.town = ''
      }
    },
    validateNation() {
      let validNations = Array.from(this.nations.keys())
      let validNationsRegex = validNations.map(nation => nation.toUpperCase()).join('|')
      return {required: true, regex: validNationsRegex}
    },
    stateValidation(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref)
      } else {
        return null
      }
    }
  }
}
</script>


<style scoped>

#old-barcode.fix-radius {
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
}

.suggestions-list {
  position: absolute;
  background-color: white;
  border: 1px solid #ccc;
  z-index: 1000;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  top: 100%; /* si posiziona subito sotto l'input */
  left: 0;
}

.suggestion-item {
  padding: 8px;
  cursor: pointer;
  background: white;
}

.suggestion-item:hover {
  background-color: #f8f9fa;
}
</style>
